import React, { FC } from "react";

import type { Invoice, Job } from "../../../types/InvoiceTypes";
import { formatAmount } from "../../../utils/numbers/money";
import { useInvoiceCurrencies } from "../../../hooks/useInvoiceCurrencies";

type Props = {
  invoice: Invoice;
};

export const JobsList: FC<Props> = ({ invoice }) => {
  const { items } = invoice;
  const invoiceCurrencies = useInvoiceCurrencies(invoice);
  const incomingCurrencySymbol = invoiceCurrencies?.incoming?.symbol;

  return (
    <div className="flex flex-col w-full">
      <header className="flex flex-row justify-between items-center py-4 w-full">
        <span className="theme-caption uppercase">Job</span>
        <span className="theme-caption uppercase">Sum</span>
      </header>

      <ul className="flex flex-col">
        {items?.map(({ description, rate, incoming_rate }: Job) => (
          <li
            className="flex flex-row justify-between items-center py-4 mb-8 last:mb-0 w-full border-t border-gray-50"
            key={description}
          >
            <span className="theme-text flex-1 basis-9/12 break-all">
              {description}
            </span>

            <span className="theme-text flex-1 basis-3/12 max-w-[300px] text-right">
              {formatAmount(incoming_rate || rate)}
              &nbsp;
              <span className="uppercase">{incomingCurrencySymbol}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
